import { Assert } from '@cotera/utilities';
import { createContext, useContext } from 'react';
import { TaxonomyColumnModel } from './taxonomy-column.model';

export const ColumnModelContext = createContext<TaxonomyColumnModel | null>(
  null
);

export const useColumnModel = () => {
  const model = useContext(ColumnModelContext);
  Assert.assert(model !== null, 'Column model not found');
  return model;
};
